import { useEffect, useState } from "react";

/** Handy-Breite: Kalender mit normaler Tableiste statt Vollbildbetrieb (Tablet/Wanddisplay). */
export const PHONE_QUERY = "(max-width: 599px)";

export function useMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== "undefined" && window.matchMedia?.(query).matches === true);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatches(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return matches;
}

export const useIsPhone = () => useMedia(PHONE_QUERY);
